import React, { createContext, ReactNode, useCallback, useContext } from 'react';

import { ExtendedWorkspaceListItem } from '@futrli/views/operations/workspaces/processors/workspacesList';
import { useModal } from '@futrli/shared-services';

import { WorkspaceSettingsSidebar } from '../../sidebars/workspace-settings-sidebar/workspace-settings-sidebar';

interface WorkspacesActionsContextValue {
  handleWorkspaceSettingsClick: (workspace: ExtendedWorkspaceListItem) => void;
}

const WorkspacesActionsContext = createContext<WorkspacesActionsContextValue>(
  ({} as unknown) as WorkspacesActionsContextValue
);

export const WorkspacesActionsProvider = ({ children }: { children: ReactNode }) => {
  const workspaceSettingsSidebar = useModal();

  const [workspace, setWorkspace] = React.useState<ExtendedWorkspaceListItem>();

  const handleWorkspaceSettingsClick = useCallback(
    (workspace: ExtendedWorkspaceListItem) => {
      setWorkspace(workspace);
      workspaceSettingsSidebar.open();
    },
    [workspaceSettingsSidebar]
  );

  const value = {
    handleWorkspaceSettingsClick
  };

  return (
    <WorkspacesActionsContext.Provider value={value}>
      <WorkspaceSettingsSidebar
        isOpen={workspaceSettingsSidebar.isOpen}
        onClose={workspaceSettingsSidebar.close}
        workspaceId={workspace?.id}
      />

      {children}
    </WorkspacesActionsContext.Provider>
  );
};

export const useWorkspacesActions = () => {
  const context = useContext(WorkspacesActionsContext);
  if (!context) {
    throw new Error('useWorkspacesActions must be used within a WorkspacesActionsProvider');
  }
  return context;
};
